import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { getTelemetry } from '@cian/telemetry/browser';

export function runApp() {
  const context = {
    config: getConfig(),
    logger: getLogger(),
    httpApi: getHttpApi(),
    telemetry: getTelemetry(),
  };

  const store = createApplicationState(context);

  renderApplication({ context, store });
}
